var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoopLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 62,
    height: 62,
    rx: 31,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 62,
    height: 62,
    rx: 31,
    stroke: "#047857",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 58C17.4551 55.3657 11.8827 51.1226 6 38.198C18.7086 38.772 24.102 41.218 31 49.0891V58Z",
    fill: "#047857"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 58V50.0792C43.1834 41.3794 48.0692 38.7576 59 38.198C55.0974 49.0547 50.129 53.4628 35.5 58Z",
    fill: "#047857"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 27.3069L33.5 30.2772L38 26.8119L40.5 27.3069V41.1683C37.4352 42.6128 35.9748 43.8683 34 47.1089C32.1647 44.1745 30.8355 42.8456 28 41.1683V28.7921L29.5 27.3069Z",
    fill: "#047857"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 31.2673H14H13L12.5 32.2574V33.7426V34.7327V35.7228L13 36.7129H14H15L16 37.2079L17 38.198H18L21.5 34.7327L22.5 33.7426V33.2475L23 32.7525V32.2574H22.5L22 31.7624L21.5 31.2673V30.7723L22 30.2772L22.5 29.2871L23 28.297V27.802V27.3069V26.8119V26.3168V25.8218L22.5 25.3267L22 24.3366L21.5 23.8416H20.5H19.5H19H18L17.5 24.3366H17H16.5L16 25.3267L15.5 25.8218L15 26.3168V27.3069V27.802V28.7921L15.5 29.7822H16L16.5 30.2772V31.2673Z",
    fill: "#047857"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25 34.7327H24H23L21 38.198L22 38.6931L22.5 39.6832H23.5H25V34.7327Z",
    fill: "#047857"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43 39.6832V34.2376H44.5L45 35.2277L45.5 36.2178L46 37.703L45 39.6832H43Z",
    fill: "#047857"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 30.2772H50.5H50V29.7822L51 28.7921L52 28.297L52.5 27.802L52 26.8119V25.8218L51.5 24.3366L50.5 23.3465L49.5 22.8515H48H47L45.5 23.3465L44.5 24.3366L44 25.3267L43.5 26.8119V28.297L45.5 29.2871V29.7822L43.5 30.2772V31.2673L44.5 32.7525L45.5 33.2475L46 33.7426L47 37.2079C47.1667 37.538 47.6 38.198 48 38.198H49L49.5 37.2079H51L52.5 36.7129V30.2772Z",
    fill: "#047857"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30 24.3366V25.3267V25.8218L33.5 28.297L36 26.8119L37 25.8218L37.5 25.3267V24.8317V23.8416V22.8515L37 22.3564L36 21.3663H35H34H33H32L31 21.8614V22.8515L30 24.3366Z",
    fill: "#047857"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 8H33.5H35.5L37 8.49505L37.5 9.9802L38.5 11.9604L39 13.9406V15.4257L38 16.9109L36.5 18.8911L35 19.8812H33.5H32L31 19.1396L29.5 17.901L29 16.9109L28 14.9307V12.9505L28.5 11.4653L29 10.4752L30.5 8.9901L31.5 8Z",
    fill: "#047857"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M31 58C17.4551 55.3657 11.8827 51.1226 6 38.198C18.7086 38.772 24.102 41.218 31 49.0891V58Z",
    stroke: "#059669"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 58V50.0792C43.1834 41.3794 48.0692 38.7576 59 38.198C55.0974 49.0547 50.129 53.4628 35.5 58Z",
    stroke: "#059669"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 27.3069L33.5 30.2772L38 26.8119L40.5 27.3069V41.1683C37.4352 42.6128 35.9748 43.8683 34 47.1089C32.1647 44.1745 30.8355 42.8456 28 41.1683V28.7921L29.5 27.3069Z",
    stroke: "#059669"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 31.2673H14H13L12.5 32.2574V33.7426V34.7327V35.7228L13 36.7129H14H15L16 37.2079L17 38.198H18L21.5 34.7327L22.5 33.7426V33.2475L23 32.7525V32.2574H22.5L22 31.7624L21.5 31.2673V30.7723L22 30.2772L22.5 29.2871L23 28.297V27.802V27.3069V26.8119V26.3168V25.8218L22.5 25.3267L22 24.3366L21.5 23.8416H20.5H19.5H19H18L17.5 24.3366H17H16.5L16 25.3267L15.5 25.8218L15 26.3168V27.3069V27.802V28.7921L15.5 29.7822H16L16.5 30.2772V31.2673Z",
    stroke: "#059669"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25 34.7327H24H23L21 38.198L22 38.6931L22.5 39.6832H23.5H25V34.7327Z",
    stroke: "#059669"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43 39.6832V34.2376H44.5L45 35.2277L45.5 36.2178L46 37.703L45 39.6832H43Z",
    stroke: "#059669"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 30.2772H50.5H50V29.7822L51 28.7921L52 28.297L52.5 27.802L52 26.8119V25.8218L51.5 24.3366L50.5 23.3465L49.5 22.8515H48H47L45.5 23.3465L44.5 24.3366L44 25.3267L43.5 26.8119V28.297L45.5 29.2871V29.7822L43.5 30.2772V31.2673L44.5 32.7525L45.5 33.2475L46 33.7426L47 37.2079C47.1667 37.538 47.6 38.198 48 38.198H49L49.5 37.2079H51L52.5 36.7129V30.2772Z",
    stroke: "#059669"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M30 24.3366V25.3267V25.8218L33.5 28.297L36 26.8119L37 25.8218L37.5 25.3267V24.8317V23.8416V22.8515L37 22.3564L36 21.3663H35H34H33H32L31 21.8614V22.8515L30 24.3366Z",
    stroke: "#059669"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 8H33.5H35.5L37 8.49505L37.5 9.9802L38.5 11.9604L39 13.9406V15.4257L38 16.9109L36.5 18.8911L35 19.8812H33.5H32L31 19.1396L29.5 17.901L29 16.9109L28 14.9307V12.9505L28.5 11.4653L29 10.4752L30.5 8.9901L31.5 8Z",
    stroke: "#059669"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoopLogo);
export default __webpack_public_path__ + "static/media/coop-logo.dc6eeecdd35ef28e7004257e52c46e3c.svg";
export { ForwardRef as ReactComponent };